var exports = {
  "l": "appleImageBox__PuOcyO",
  "K": "googleImageBox__sSilg_",
};

module.exports = exports;
